{
  "GENERAL": {
    "CLOSE": "Cerrar",
    "SHOWING_RESULTS": "Mostrando {firstIndex}-{lastIndex} de {totalCount} elementos",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Buscar",
      "EMPTY_STATE": "No se encontraron resultados"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Se requieren al menos {count}"
  }
}
